/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: nMR4ibQ-Ep

import * as React from "react";

import {
  Flex as Flex__,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import ProjectList from "../../components/ProjectList"; // plasmic-import: -k-p1OXXphn/component
import DefaultLayout from "../../components/dashboard/DefaultLayout"; // plasmic-import: nSkQWLjK-B/component
import NavTeamSection from "../../components/dashboard/NavTeamSection"; // plasmic-import: VqaN_WL-stA/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicAllProjectsPage.module.css"; // plasmic-import: nMR4ibQ-Ep/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  },
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    },
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary" as const,
    },
  };
}

createPlasmicElementProxy;

export type PlasmicAllProjectsPage__VariantMembers = {};
export type PlasmicAllProjectsPage__VariantsArgs = {};
type VariantPropType = keyof PlasmicAllProjectsPage__VariantsArgs;
export const PlasmicAllProjectsPage__VariantProps =
  new Array<VariantPropType>();

export type PlasmicAllProjectsPage__ArgsType = {};
type ArgPropType = keyof PlasmicAllProjectsPage__ArgsType;
export const PlasmicAllProjectsPage__ArgProps = new Array<ArgPropType>();

export type PlasmicAllProjectsPage__OverridesType = {
  root?: Flex__<"div">;
  defaultLayout?: Flex__<typeof DefaultLayout>;
  projectList?: Flex__<typeof ProjectList>;
  navTeamSection?: Flex__<typeof NavTeamSection>;
};

export interface DefaultAllProjectsPageProps {
  className?: string;
}

const $$ = {};

function PlasmicAllProjectsPage__RenderFunc(props: {
  variants: PlasmicAllProjectsPage__VariantsArgs;
  args: PlasmicAllProjectsPage__ArgsType;
  overrides: PlasmicAllProjectsPage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_ooL7EhXDmFQWnW9sxtchhE",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <DefaultLayout
            data-plasmic-name={"defaultLayout"}
            data-plasmic-override={overrides.defaultLayout}
            className={classNames("__wab_instance", sty.defaultLayout)}
            navigation={"allProjects"}
            newProjectButtonAsDropdown={true}
            teams={
              <NavTeamSection
                data-plasmic-name={"navTeamSection"}
                data-plasmic-override={overrides.navTeamSection}
                className={classNames("__wab_instance", sty.navTeamSection)}
              />
            }
          >
            <ProjectList
              data-plasmic-name={"projectList"}
              data-plasmic-override={overrides.projectList}
              className={classNames("__wab_instance", sty.projectList)}
            />
          </DefaultLayout>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "defaultLayout", "projectList", "navTeamSection"],
  defaultLayout: ["defaultLayout", "projectList", "navTeamSection"],
  projectList: ["projectList"],
  navTeamSection: ["navTeamSection"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  defaultLayout: typeof DefaultLayout;
  projectList: typeof ProjectList;
  navTeamSection: typeof NavTeamSection;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAllProjectsPage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAllProjectsPage__VariantsArgs;
    args?: PlasmicAllProjectsPage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicAllProjectsPage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicAllProjectsPage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAllProjectsPage__ArgProps,
          internalVariantPropNames: PlasmicAllProjectsPage__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicAllProjectsPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAllProjectsPage";
  } else {
    func.displayName = `PlasmicAllProjectsPage.${nodeName}`;
  }
  return func;
}

export const PlasmicAllProjectsPage = Object.assign(
  // Top-level PlasmicAllProjectsPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    defaultLayout: makeNodeComponent("defaultLayout"),
    projectList: makeNodeComponent("projectList"),
    navTeamSection: makeNodeComponent("navTeamSection"),

    // Metadata about props expected for PlasmicAllProjectsPage
    internalVariantProps: PlasmicAllProjectsPage__VariantProps,
    internalArgProps: PlasmicAllProjectsPage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/projects",
      pagePath: "/projects",
      params: {},
      query: {},
    }),
  }
);

export default PlasmicAllProjectsPage;
/* prettier-ignore-end */
